import { render, staticRenderFns } from "./AamsRegSealDisposalApproval.vue?vue&type=template&id=62dedfa8&scoped=true&"
import script from "./AamsRegSealDisposalApproval.vue?vue&type=script&lang=js&"
export * from "./AamsRegSealDisposalApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dedfa8",
  null
  
)

export default component.exports